interface IHeaderConfigArgs {
  title?: { icon?: string, label?: string, path?: string };
}

export const headerInitialState = {
  title: { icon: "", label: "", path: "" },
};

const headerConfigs = {
  /* Dashboard Header Params */
  dashboard(customArgs: IHeaderConfigArgs = {}) {
    const header: IHeaderConfigArgs = {
      title: { icon: "Dashboard", label: "Dashboard", path: "/" },
    };
    return spreader(header, customArgs);
  },

  /* Users Header Params */
  users(customArgs: IHeaderConfigArgs = {}) {
    const header: IHeaderConfigArgs = {
      title: { icon: "Users", label: "Users", path: "/users" },
    };
    return spreader(header, customArgs);
  },

  /* Payments Header Params */
  payments(customArgs: IHeaderConfigArgs = {}) {
    const header: IHeaderConfigArgs = {
      title: { icon: "Payments", label: "Payments", path: "/payments" },
    };
    return spreader(header, customArgs);
  },

};

const spreader = (header: IHeaderConfigArgs, customArgs: IHeaderConfigArgs) => {
  return {
    ...headerInitialState, ...header, ...customArgs,
  };
};

export default headerConfigs;
